module.exports = __webpack_public_path__ + "media/flags/bf-a0697cd7.svg";